import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { LoadingStatus, NavigationBlocker } from '@paycor/pacl';
import { redirectOnUnauthenticated } from 'utils/authentication';
import { Security } from 'paycor-react-oidc';
import { Privs } from 'constants';
import AuthorizeUserPrivilege from 'components/Security/AuthorizeUserPrivilege';
import config from 'config';
import EmployeeSettingsTabbedView from 'page/EmployeeSettingsTabbedView';

const onAuthFailed = () => {
	console.error(`authFailed triggered`);
	redirectOnUnauthenticated();
};

const onAuthError = () => {
	console.error(`authError triggered`);
	redirectOnUnauthenticated();
};

const App = () => {
	return (
		<Router basename={'/employeesettings'}>
			<Security
				settings={config.securitySettings}
				onUnAuthorizedCallback={onAuthFailed}
				onAuthErrorCallback={onAuthError}
				consoleLogsEnabled={true}
				loaderComponent={<LoadingStatus />}
			>
				<NavigationBlocker>
					<Route path={'/Company/:companyId/Client/:clientId'}>
						<AuthorizeUserPrivilege privileges={{ view_priv: Privs.EMPLOYEE_VIEW_SETTINGS, edit_priv: Privs.EMPLOYEE_EDIT_SETTINGS }} pageName={'Employee Settings'}>
							<EmployeeSettingsTabbedView />
						</AuthorizeUserPrivilege>
					</Route>
				</NavigationBlocker>
			</Security>
		</Router>
	);
};

export default App;
